module.exports = __webpack_public_path__ + "img/Work.3b92192d.svg";